var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.614,
    height: 11.135,
    viewBox: "0 0 15.614 11.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.522,19.431l-9.512,9.512a.388.388,0,0,1-.555,0L5.142,23.632a.388.388,0,0,1,0-.555l.833-.833a.388.388,0,0,1,.555,0l4.2,4.2,8.4-8.4a.388.388,0,0,1,.555,0l.833.833A.388.388,0,0,1,20.522,19.431Z",
    transform: "translate(-5.025 -17.925)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupTick);
export default __webpack_public_path__ + "static/media/signupTick.9de5a3b3fb3b2ce3ec1c7ca44c44f8dd.svg";
export { ForwardRef as ReactComponent };